export const getHasParentWidget = (): boolean => {
  if (window.parent === window.self) return false; // Top window, нет parent

  try {
    const isSameOrigin = window.location.origin === window.parent.origin;
    if (!isSameOrigin) {
      return false;
    }

    const parentHref = window.parent.location.href;
    const selfHref = window.location.href;

    const selfIsPw = selfHref.includes('/pw/');
    const parentIsPw = parentHref.includes('/pw/');

    if (selfIsPw && !parentIsPw) {
      return false;
    }

    const widgetKeywords = ['deposit', 'withdrawal', 'cashier', 'demeter'];
    return widgetKeywords.some((keyword) => parentHref.includes(keyword));
  } catch {
    return false;
  }
};
